
import { LOADING_TYPE } from "../constants";

export const showLoading = () =>
   async (dispatch) => {
      dispatch({
         type: LOADING_TYPE.SHOW
      });
   };

export const hideLoading = () =>
   async (dispatch) => {
      dispatch({
         type: LOADING_TYPE.HIDE
      });
   };
